import PropTypes from 'prop-types';
import React from 'react';
import SearchDate from '../SearchDate';
import SelectNumber from '@components/_Layout/Controls/SelectNumber';
import { useSession } from '@hooks';

type SearchDatesProps = {
  isDateRange: boolean,
  showDuration: boolean,
  duration?: number,
  startDate?: any,
  endDate?: any,
  onStartDateChange?: (date: Date | null) => void,
  onEndDateChange?: (date: Date | null) => void,
  onDurationChange?: (e: any) => void,
  onDateRangePickerChange?: (date: [Date | null, Date | null]) => void
};

const languagesVarsCodes = [
  "LANG_neobooking_departure_from_to", //Arrivée - Départ
  "LANG_neobooking_departure_from", //Arrivée
  "LANG_neobooking_departure_to", //Départ
  "LANG_neobooking_departure_nights", //Nuitées
]

const SearchDates: React.FC<SearchDatesProps> = ({
  isDateRange,
  showDuration,
  duration,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onDurationChange,
  onDateRangePickerChange }) => {

  /* Hooks */
  const { getLanguageVarValue } = useSession();

  return <>
    {
      (isDateRange && onDateRangePickerChange) ? (
        <div className="tw-col-span-12 sm:tw-col-span-4">
          <SearchDate
            inputType="daterangepicker"
            minDate={new Date()}
            additionalClassname={"tw-w-full"}
            //required={true}
            startDate={startDate}
            endDate={endDate}
            placeholderText={getLanguageVarValue("LANG_neobooking_departure_from_to")}
            onChange={onDateRangePickerChange}
          />
        </div>
      ) : (showDuration && onStartDateChange && onDurationChange) ? (
        <>
          <div className="tw-col-span-12 sm:tw-col-span-2">
            <SearchDate
              inputType="datepicker"
              minDate={new Date()}
              //required={true}
              placeholderText={getLanguageVarValue("LANG_neobooking_departure_from")}
              selected={startDate}
              onChange={onStartDateChange}
              additionalClassname={"tw-w-full"}
            />
          </div>
          <div className="tw-col-span-12 sm:tw-col-span-2">
            <SelectNumber
              placeholder={getLanguageVarValue("LANG_neobooking_departure_nights")}
              value={duration}
              onChange={onDurationChange}
              quantity={8}
              start={1}
              label="nuit"
              pluralLabel="nuits"
              additionalClassname="tw-w-full"
            />
          </div>
        </>
      ) : (onStartDateChange && onEndDateChange) && (
        <>
          <div className="tw-col-span-12 sm:tw-col-span-2">
            <SearchDate
              inputType="datepicker"
              minDate={new Date()}
              selected={startDate}
              //required={true}
              placeholderText={getLanguageVarValue("LANG_neobooking_departure_from")}
              onChange={onStartDateChange}
              additionalClassname={"tw-w-full"}
            />
          </div>
          <div className="tw-col-span-12 sm:tw-col-span-2">
            <SearchDate
              inputType="datepicker"
              minDate={startDate}
              //required={true}
              selected={endDate}
              placeholderText={getLanguageVarValue("LANG_neobooking_departure_to")}
              onChange={onEndDateChange}
              additionalClassname={"tw-w-full"}
            />
          </div>
        </>
      )
    }
  </>;
};

SearchDates.propTypes = {
  //
};

export default SearchDates;
